import { render, staticRenderFns } from "./SelectionOption.vue?vue&type=template&id=2f10036c&scoped=true"
import script from "./SelectionOption.vue?vue&type=script&lang=js"
export * from "./SelectionOption.vue?vue&type=script&lang=js"
import style0 from "./SelectionOption.vue?vue&type=style&index=0&id=2f10036c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10036c",
  null
  
)

export default component.exports